module.exports = __webpack_public_path__ + "img/icons_duration.753bb192.svg";